import planYourWeek from '../../images/plan-your-week.png';
import checkThemOff from '../../images/check-them-off.png';
import pushIt from '../../images/push-it.png';
import details from '../../images/details.png';
import history from '../../images/history.png';


function LandingScreen() {

  return (
    <div class='landing-screen'>

      {/* Header */}
      <div class='header-background'></div>

      <header class='flex-column'>
        <div class='container-primary'>

          <nav class='flex-column landing-main-nav'>
            <div class='container-primary'>
              <div class='container-links'>
                  {/* <span>BETA</span> */}
                  <a href='/login'>Login</a>
              </div>
            </div>
          </nav>

          <div class='flex-column hero'>

            <div class='logo'></div>
            <h1>
              <small>Organize Your Week</small>
              <br />
              get sh!t done
            </h1>

            <a href='/register'>Try It Out</a>
          </div>

        </div>
      </header>


      {/* Value Prop 1 */}
      <section class='flex-column prop_one'>
        <div class='flex-column banner-wide'>
          <div class='container-primary'>
            <h3 style={{textAlign: 'center'}}>The <i>simple</i>, easy task manager</h3>
            <p class='p-major' style={{marginBottom: 'initial'}}>to plan today, tomorrow, and <span style={{whiteSpace: 'nowrap'}}>the next 7 days</span></p>
          </div>
        </div>
      </section>


      {/* Value Prop 2 */}
      <section class='flex-column prop_two'>
        <div class='flex-column container-primary'>
          <h2>Simple by Design</h2>
          <p class='p-major'>
            <i>Don't over complicate it.</i> Dia Daily was built to help you keep track of what you need to do now, plan ahead for the next several days, and check things off as you go.
          </p>

          <a href='/register'>Get Started</a>
        </div>
      </section>


      {/* How */}
      <section class='flex-column prop_how'>
        <div class='flex-column container-primary'>
          <h2>How Does It Work?</h2>
        </div>

        <div class='spacer-60'></div>

        {/* How 1 */}
        <div class='flex-row how-item-container mobile-flip'>
          <div class='flex-row how-left-image-container'>
            <img src={planYourWeek} />
          </div>
          <div class='how-right-text'>
            <h3>Plan your week</h3>
            <p class='p-major-minor'>Add tasks for today, tomorrow, and the next 7 days</p>
          </div>
        </div>

        {/* How 2 */}
        <div class='flex-row how-item-container'>
          <div class='how-left-text'>
            <h3>Check them off</h3>
            <p class='p-major-minor'>Finished that task? Check it off and move to the next one</p>
          </div>
          <div class='flex-row how-right-image-container'>
            <img src={checkThemOff} />
          </div>
        </div>

        {/* How 3 */}
        <div class='flex-row how-item-container mobile-flip'>
          <div class='flex-row how-left-image-container'>
            <img src={pushIt} />
          </div>
          <div class='how-right-text'>
            <h3>Didn't finish something?</h3>
            <p class='p-major-minor'><i>No sweat</i>. Just push unfinished tasks to the next day.</p>
          </div>
        </div>

        {/* How 4 */}
        <div class='flex-row how-item-container'>
          <div class='how-left-text'>
            <h3>Labels, due dates, links</h3>
            <p class='p-major-minor'><i>You bet</i>. Label your tasks to keep them organized. Add those due dates. Include the link</p>
          </div>
          <div class='flex-row how-right-image-container'>
            <img src={details} />
          </div>
        </div>

        {/* How 5 */}
        <div class='flex-row how-item-container mobile-flip'>
          <div class='flex-row how-left-image-container'>
            <img src={history} />
          </div>
          <div class='how-right-text'>
            <h3>See back in time</h3>
            <p class='p-major-minor'>Look through the history to find past tasks.</p>
          </div>
        </div>

      </section>


      {/* Pricing */}
      <section class='flex-column section-pricing'>
        <div class='flex-column container-primary'>
          <h2>Pricing</h2>
          <p class='p-major'>Dia Daily is free to use. Enjoy.</p>
          <p>&nbsp;</p>
          <p class='p-major-minor'>
            <a href='/register'>Create your account</a>
          </p>
        </div>
      </section>


      <footer class='flex-column'>
        <div class='flex-column container-primary'>
          <p class='p-major-minor'>
            <a href='mailto:diastandup@gmail.com'>diastandup@gmail.com</a>
          </p>

          <div class='spacer-60'></div>

          <p class='p-minor'>Dia Daily was made by <a href='https://www.linkedin.com/in/johngoodman09/' target='_blank'>John Goodman</a>.</p>
          {/* <p class='minor'>You’re welcome to buy me a coffee if you are enjoying Dia Daily</p> */}
        </div>
      </footer>


    </div>
  )
}

export default LandingScreen;